import { HttpClient, ApiConfig } from './api/http-client';
import { AxiosResponse } from 'axios';
import useLogger from 'src/composables/loggerUtils';
const logger = useLogger();

export abstract class Services {
  public static apiConfig = {
    secure: true,
    baseURL: process.env.API_URL,
    paramsSerializer: { indexes: null },
  };

  public static getService = <T extends HttpClient<unknown>>(service: {
    new (config: ApiConfig<unknown>): T;
  }): T => {
    const api = new service(this.apiConfig);
    api.instance.interceptors.response.use(
      (res: AxiosResponse<unknown, unknown>) => res,
      async (error) => {
        //const ignoreUserAccountError =
        //   error.config.url == '/api/Account' && error.response?.status == 401;
        const ignoreError = error.response && error.response?.status == 401;
        if (!ignoreError) {
          logger.logError('API Error: ' + error?.message, {
            name: error?.name,
            message: error?.message,
            stack: error?.stack,
            code: error?.code,
            status: error?.status,
            url: error?.config?.baseURL + '' + error?.config?.url,
            method: error?.config.method,
          });
        }
        // Must return the error to allow other promises to resolve
        return Promise.reject(error);
      },
    );
    return api;
  };
}
